/**
 * @generated SignedSource<<7f1af34ad048850cccfdf271ecde4868>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueCreateContext_businessIssueCreate_IssueCreateProvider$data = {
  readonly jira: {
    readonly rankField: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fieldId: string;
        };
      }>;
    } | null | undefined;
  };
  readonly " $fragmentType": "issueCreateContext_businessIssueCreate_IssueCreateProvider";
};
export type issueCreateContext_businessIssueCreate_IssueCreateProvider$key = {
  readonly " $data"?: issueCreateContext_businessIssueCreate_IssueCreateProvider$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueCreateContext_businessIssueCreate_IssueCreateProvider">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "issueCreateContext_businessIssueCreate_IssueCreateProvider",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "rankField",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Literal",
                    "name": "aliasFieldIds",
                    "value": [
                      "rank"
                    ]
                  },
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "JiraFieldConfigConnection",
            "kind": "LinkedField",
            "name": "jiraFieldConfigs",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "JiraFieldConfigEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "concreteType": "JiraIssueFieldConfig",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "kind": "ScalarField",
                              "name": "fieldId"
                            },
                            "action": "THROW",
                            "path": "jira.rankField.edges.node.fieldId"
                          }
                        ]
                      },
                      "action": "THROW",
                      "path": "jira.rankField.edges.node"
                    }
                  ]
                },
                "action": "THROW",
                "path": "jira.rankField.edges"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};

(node as any).hash = "7f2e3959fda849b5d0b1ac2929532dd6";

export default node;
